/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import {
	SOFTWARE_PROJECT,
	CORE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';
import { useUnreadComment } from './utils.tsx';

const CustomCommentUnreadIndicator = () => {
	const { formatMessage } = useIntl();

	const {
		isDeleted,
		commentId,
		showNewUnreadCommentLozenge,
		setUnreadCommentScrollRef,
		projectType,
	} = useCommentContext();
	const isUnreadComment = useUnreadComment();
	const isEligibleProjectType = projectType === SOFTWARE_PROJECT || projectType === CORE_PROJECT;

	if (
		!isDeleted &&
		isEligibleProjectType &&
		isUnreadComment &&
		expVal('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)
	) {
		return (
			<Box
				as="span"
				ref={setUnreadCommentScrollRef}
				testId={`issue-comment-base.ui.comment.unread.${commentId}`}
				xcss={[unreadCss, showNewUnreadCommentLozenge && unreadNewBadgeCss]}
			>
				{showNewUnreadCommentLozenge && formatMessage(messages.new)}
			</Box>
		);
	}
	return null;
};

const AkCommentUnreadIndicator = () => {
	const { formatMessage } = useIntl();

	const {
		isDeleted,
		commentId,
		isUnreadComment,
		showNewUnreadCommentLozenge,
		setUnreadCommentScrollRef,
		projectType,
	} = useCommentContext();

	const isEligibleProjectType = projectType === SOFTWARE_PROJECT || projectType === CORE_PROJECT;

	if (
		!isDeleted &&
		isEligibleProjectType &&
		isUnreadComment &&
		expVal('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)
	) {
		return (
			<Box
				as="span"
				ref={setUnreadCommentScrollRef}
				testId={`issue-comment-base.ui.comment.unread.${commentId}`}
				xcss={[unreadCss, showNewUnreadCommentLozenge && unreadNewBadgeCss]}
			>
				{showNewUnreadCommentLozenge && formatMessage(messages.new)}
			</Box>
		);
	}
};

const CommentUnreadIndicator = componentWithFG(
	'jira_custom_comment_component_refactor',
	CustomCommentUnreadIndicator,
	AkCommentUnreadIndicator,
);
export default CommentUnreadIndicator;

const unreadCss = xcss({
	height: token('space.075'),
	width: token('space.075'),
	borderRadius: 'border.radius.circle',
	backgroundColor: 'color.background.accent.blue.bolder',
	transition: 'all 0.2s ease-in-out',
});
const unreadNewBadgeCss = xcss({
	textAlign: 'center',
	font: 'font.body.small',
	color: 'color.text.inverse',
	width: token('space.500'),
	height: token('space.200'),
	borderRadius: 'border.radius.200',
});
